<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Informes de Pagos Jugadores</v-toolbar-title>
    </v-toolbar>
    <div v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <informes-table path="informes/jugadores"></informes-table>
    </div>
  </div>

</template>

<script>
import InformesTable from '../components/InformesTable'

export default {

  components: {
    InformesTable
  },

  data () {
    return {
      loading: true
    }
  },

  mounted () {
    this.loading = false
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em;
  }
</style>
